import { render } from "./EditContractTemplate.vue?vue&type=template&id=cab36006"
import script from "./EditContractTemplate.vue?vue&type=script&lang=js"
export * from "./EditContractTemplate.vue?vue&type=script&lang=js"

import "./EditContractTemplate.vue?vue&type=style&index=0&id=cab36006&lang=css"

import exportComponent from "/Users/elisabetta/Code/salvi-rental/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__